'use client'

import { useAuthRedirect } from '@features/auth'
import { GatewaySearchParams } from '@server/schemas'
import { useEffect } from 'react'

export const AppGatewayPage = ({ destination = 'HOME', ...additionalParams }: GatewaySearchParams) => {
  const handleAuthRedirect = useAuthRedirect(destination, additionalParams)

  useEffect(() => {
    handleAuthRedirect()
  }, [handleAuthRedirect])

  return null
}
